import React from 'react';
import {Item, Icon, ItemName, ItemContent} from './Footeritem'

import iconSet from "../../icons/selection.json";
import IcomoonReact, { iconList } from "icomoon-react";


export default function Refcard(props){

    const {iconname,itemname,itemcontent, ...otherProps} = props;

return(
    
    <Item>

            <Icon>
                <IcomoonReact iconSet={iconSet} color="#faf9f9" style={{ height: "2rem", width: "2rem", margin: "0 auto" }} icon={iconname} />
            </Icon>



        <ItemName>
           {itemname}
        </ItemName>

        
        <ItemContent>
           {itemcontent}
        </ItemContent>
        

        

    </Item>
    
)

}